import React from 'react';
import PageContainer from '../../../../CSIComponents/PageContainer';
import DetailItem from './../../../../CSIComponents/DetailItem';
import ReadOnlyTextarea from './../../../../CSIComponents/ReadOnlyTextarea';
import { Row, Col } from 'antd';
import './../roomType.css';
import styles from '../../index.module.css';

const RoomTypeView = (props: any) => {
  const getBeds = () => {
    return props.currentRow.detail.beds.map(
      (item: { bedtype: string; noofbeds: string }, index: number) => {
        return (
          <Row
            gutter={24}
            key={index}
          >
            <Col
              span={7}
              className="col-margin"
            >
              <DetailItem
                value={item.bedtype}
                label={`Bed Type ${index + 1}`}
              />
            </Col>
            <Col
              span={7}
              className="col-margin"
            >
              <DetailItem
                value={item.noofbeds}
                label={`Number of Beds ${index + 1}`}
              />
            </Col>
          </Row>
        );
      }
    );
  };

  return (
    <PageContainer>
      <Row gutter={24}>
        <Col
          span={8}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.id}
            label="Room ID"
          />
        </Col>
        <Col
          span={8}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.type}
            label="Room Type or Class"
          />
        </Col>
        {props.supplier === 'MGM' && (
          <Col
            span={8}
            className="col-margin"
          >
            <DetailItem
              value={props.currentRow.detail.lanyonType}
              label="Lanyon Room Type"
            />
          </Col>
        )}
      </Row>
      <Row gutter={24}>
        <Col
          span={16}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.name}
            label="Room Type Name"
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col
          span={8}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.maxoccupancy}
            label="Maximum Occupancy"
          />
        </Col>
        <Col
          span={8}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.minoccupancy}
            label="Minimum Occupancy"
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col
          span={8}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.maxadults}
            label="Maximum Adults"
          />
        </Col>
        <Col
          span={8}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.maxchildren}
            label="Maximum Children"
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col
          span={16}
          className="col-margin"
        >
          <ReadOnlyTextarea
            value={props.currentRow.description}
            label="Description"
          />
        </Col>
      </Row>

      <Row gutter={24}>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.segmentcat}
            label="Segment Category"
          />
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.locationcat}
            label="Location Category"
          />
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.size}
            label="Size"
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.measurement}
            label="Measurements"
          />
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.roomview}
            label="Room View"
          />
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.accesibleindicator}
            label="Accessible Indicator"
          />
        </Col>
      </Row>
      <Row gutter={24}>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.noofbedrooms}
            label="Number of Bedrooms"
          />
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.numberofbathrooms}
            label="Number of Bathrooms"
          />
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.nonsmoking}
            label="Non-Smoking"
          />
        </Col>
      </Row>
      {getBeds()}
      <Row gutter={24}>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.maxrollaway}
            label="Maximum Rollaways"
          />
        </Col>
        <Col
          span={7}
          className="col-margin"
        >
          <DetailItem
            value={props.currentRow.detail.maxcrib}
            label="Maximum Cribs"
          />
        </Col>
      </Row>
    </PageContainer>
  );
};

export default RoomTypeView;
